import { render, staticRenderFns } from "./BlockUploadImage.vue?vue&type=template&id=bdf6c160&scoped=true&"
import script from "./BlockUploadImage.vue?vue&type=script&lang=js&"
export * from "./BlockUploadImage.vue?vue&type=script&lang=js&"
import style0 from "./BlockUploadImage.vue?vue&type=style&index=0&id=bdf6c160&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf6c160",
  null
  
)

export default component.exports